import React from 'react';

import { withFilterCars } from '../../../shared/containers/containerFilterCars'

import FormHorisontItem from './../../../shared/items/static/formHorisontItem'
import Checkbox from './../../../shared/items/contols/checkbox'
import { carsStatuses } from './static.carsStatuses'

const CarsStatusesFilter = props => {
  const { onHandleChangeStore, filterCarsListItems } = props

  return (
    <React.Fragment>
      <FormHorisontItem title={carsStatuses.inmotion.title}>
        <Checkbox
          name={carsStatuses.inmotion.name}
          valueStore={filterCarsListItems}
          handleChange={onHandleChangeStore}
        />
      </FormHorisontItem>

      <FormHorisontItem title={carsStatuses.parking.title}>
        <Checkbox
          name={carsStatuses.parking.name}
          valueStore={filterCarsListItems}
          handleChange={onHandleChangeStore}
        />
      </FormHorisontItem>

      <FormHorisontItem title={carsStatuses.loss.title}>
        <Checkbox
          name={carsStatuses.loss.name}
          valueStore={filterCarsListItems}
          handleChange={onHandleChangeStore}
        />
      </FormHorisontItem>

      <FormHorisontItem title={carsStatuses.withInActive.title}>
        <Checkbox          
          name={carsStatuses.withInActive.name}
          valueStore={filterCarsListItems}
          handleChange={onHandleChangeStore}
        />
      </FormHorisontItem>
    </React.Fragment>
  )
}

export default withFilterCars(React.memo(CarsStatusesFilter))
